import React from 'react';

import { Box, Container, Divider, Typography } from '@mui/material';

import { TryBetaButton } from './TryBetaButton';

export default function Footer() {
  const buildTimestamp = typeof __BUILD_TIMESTAMP__ !== 'undefined' ? __BUILD_TIMESTAMP__ : null;

  return (
    <Container sx={{ position: 'relative' }}>
      <Divider sx={{ my: 2 }} />

      <Box mb={2} display="flex" justifyContent="space-between">
        <Box display="flex" gap={2}>
          <Typography color="secondary" variant="body2">
            &copy; 2017 - {new Date().getFullYear()}, Luxury Escapes
          </Typography>
          <Typography color="secondary" variant="body2">
            React: v{React.version}
          </Typography>
          <Typography color="secondary" variant="body2">
            Last updated: {buildTimestamp} (Australia/Sydney)
          </Typography>
        </Box>
        <Box display="flex" alignItems="center" gap={1} mr={5}>
          <TryBetaButton />
        </Box>
      </Box>
    </Container>
  );
}
